export const UpArrowIcon = ({ fill = "var(--YW_Citations_Panel_Close_Color)" }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 10L8 5.5L12.5 10" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const upArrowIcon = <UpArrowIcon />